import {Button, IconButton, InputAdornment} from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import {Visibility, VisibilityOff} from '@material-ui/icons';
import {i18n2} from 'features/i18n/i18n';
import {Field} from 'formik';
import {TextField} from 'formik-material-ui';
import React, {useState} from 'react';

const LdapGroup = ({
  formikProps,
  passwordTypes,
  setPasswordChangeFinished,
  passwordChangeFinished,
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const [changePassword, setChangePassword] = useState(false);
  const [newPassword, setNewPassword] = useState('');

  const initChangePasswordLDAP = (formikProps) => {
    formikProps.setFieldValue('password', '');
    setChangePassword(true);
    if (passwordChangeFinished !== passwordTypes.finished)
      setPasswordChangeFinished(passwordTypes.inProgress);
    else setPasswordChangeFinished(passwordTypes.editingAgain);
  };

  const saveNewPassword = (formikProps) => {
    setNewPassword(formikProps.values.password);
    setChangePassword(false);
    setPasswordChangeFinished(passwordTypes.finished);
  };

  const cancelNewPassword = (formikProps) => {
    setChangePassword(false);
    if (passwordChangeFinished !== 3) {
      formikProps.setFieldValue('password', '***************');
      setPasswordChangeFinished(passwordTypes.notChanges);
    } else {
      formikProps.setFieldValue('password', newPassword);
      setPasswordChangeFinished(passwordTypes.finished);
    }
  };

  return (
    <Grid container spacing={2}>
      <Grid item md={3} xs={12}>
        <Field
          name="userLDAP"
          component={TextField}
          label={i18n2._('Usuario')}
          fullWidth
          variant="outlined"
          required
          size={'small'}
        />
      </Grid>
      <Grid item md={3} xs={12}>
        <Field
          name="password"
          component={TextField}
          label={i18n2._('Contraseña')}
          fullWidth
          variant="outlined"
          type={showPassword ? 'text' : 'password'}
          required
          disabled={!changePassword}
          size={'small'}
          InputProps={
            formikProps.values.password !== '***************'
              ? {
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => {
                          setShowPassword(!showPassword);
                        }}
                        edge="end">
                        {showPassword ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }
              : {}
          }
          validate={(value) => {
            let error;
            if (typeof value !== 'undefined' && value.length === 0) {
              error = i18n2._('Please provide a password');
            }
            return error;
          }}
        />
      </Grid>
      <Grid item md={3} xs={12}>
        <Field
          name="serverLDAP"
          component={TextField}
          label={i18n2._('Server de LDAP')}
          fullWidth
          variant="outlined"
          required
          size={'small'}
        />
      </Grid>
      <Grid item md={3} xs={12}>
        {passwordChangeFinished === passwordTypes.inProgress ||
        passwordChangeFinished === 3 ? (
          <>
            <Button
              color="primary"
              variant="contained"
              onClick={() => saveNewPassword(formikProps)}>
              {i18n2._('Guardar')}
            </Button>
            <Button
              className="red-background white-text"
              style={{marginLeft: '1vh'}}
              variant="contained"
              onClick={() => cancelNewPassword(formikProps)}>
              {i18n2._('Cancel')}
            </Button>
          </>
        ) : (
          <Button
            variant="outlined"
            color="primary"
            onClick={() => initChangePasswordLDAP(formikProps)}>
            {i18n2._('Cambiar contraseña')}
          </Button>
        )}
      </Grid>
    </Grid>
  );
};

export default LdapGroup;
